import _ from 'lodash';
import { Service } from 'pdk/services';
import AppConfig from '@/config';
import http, { kendoBeforeSend } from './http';


export class UserService extends Service {
	// CTOR
    constructor() {
        super();
    }


	// Users
    createUser(options) {
        const data = this._extend(options, {
            globalUserID: null,
            userName: null,
            firstName: null,
            lastName: null,
            emailAddress: null
        });

        return http.put(`ops/users/${data.globalUserID}`, data);
    }
    deleteUser(options) {
        const data = this._extend(options, {
            globalUserID: null
        });

		return http.delete(`ops/users/${data.globalUserID}`);
    }
    getUser(options) {
        const data = this._extend(options, {
            globalUserID: null
        });

        return http.get(`ops/users/${data.globalUserID}`)
            .then((response) => response.data);
    }
    getUsers_KendoDataSource() {
        var baseURL = AppConfig.api.baseURL || '/api';
        return {
            transport: {
                read: {
                    url: `${baseURL}/ops/users`,
                    type: 'POST',
                    beforeSend: kendoBeforeSend
                },
                parameterMap: function (data, type) {
                    if (data.filter != null) {
                        data.filter.filters.forEach((x) => {
                            if (x.field == "lastLoginOn") {
                                var dt = `${x.value.getMonth()+1}-${x.value.getDate()}-${x.value.getFullYear()}`;
                                x.value = dt;
                            }
                        });
                    }
                    return data;
                },
            },
            pageSize: 20,
            schema: {
                total: 'totalRows',
                data: 'users',
                model: {
                    id: 'globalUserID',
                    fields: {
                        userName: { type: 'string' },
                        firstName: { type: 'string' },
                        lastName: { type: 'string' },
                        emailAddress: { type: 'string' },
                        lastLoginOn: { type: 'date' }
                    }
                }
            }
        };
    }

    // Candidates
    getCandidates_KendoDataSource() {
        var baseURL = AppConfig.api.baseURL || '/api';
        return {
            transport: {
                read: {
                    url: `${baseURL}/ops/users/candidates`,
                    type: 'POST',
                    beforeSend: kendoBeforeSend
                }
            },
            pageSize: 20,
            schema: {
                total: 'totalRows',
                data: 'users',
                model: {
                    id: 'globalUserID',
                    fields: {
                        userName: { type: 'string' },
                        firstName: { type: 'string' },
                        lastName: { type: 'string' },
                        emailAddress: { type: 'string' },
                        workAreaID: { type: 'number', nullable: true }
                    }
                }
            }
        };
    }

    // Dashboard permissions
    getDashboardPermissions(options) {
        const data = this._extend(options, {
            globalUserID: null,
            locationGroupID: null
        });

        return http.get(`ops/users/${data.globalUserID}/permissions`)
            .then((response) => {
                const permissions = response.data;

                const result = (data.locationGroupID)
                    ? _.filter(permissions, (g) => g.locationGroupID == data.locationGroupID)
                    : permissions;

                return _.orderBy(result, [(r) => r.reportName]);
            });
    }
    updateDashboardPermissions(options) {
        const data = this._extend(options, {
            globalUserID: null,
            permissions: []
        });

        return http.put(`ops/users/${data.globalUserID}/permissions`, data.permissions);
    }
    verifyDeleteUserPermission(options) {
        const data = this._extend(options, {
            globalUserID: null            
        });

        return http.get(`ops/users/${data.globalUserID}/delete`)
            .then((response) => response.data);
    }

    // Location groups
    addUserToGroups(options) {
        const data = this._extend(options, {
            globalUserID: null,
            groups: []
        });

        return http.put(`ops/users/${data.globalUserID}/groups`, data.groups);
    }
    getLocationGroups(options) {
        const data = this._extend(options, {
            globalUserID: null,
            locationGroupID: null
        });

        return http.get(`ops/users/${data.globalUserID}/groups`)
            .then((response) => {
                const groups = response.data;

                const result = (data.locationGroupID)
                    ? _.filter(groups, (g) => g.locationGroupID == data.locationGroupID)
                    : groups;

                return _.orderBy(result, [(r) => r.reportName]);
            });
    }
    updateLocationGroup(options) {
        const data = this._extend(options, {
            globalUserID: null,
            locationGroupID: null,
            role: null
        });

        return http.put(`ops/users/${data.globalUserID}/groups/${data.locationGroupID}`, data);
    }

    // Work areas
	getWorkAreas() {
        return http.get(`ops/users/workareas`)
            .then((response) => response.data);
    }
}

export default new UserService();
